module.exports = __webpack_public_path__ + "static/media/loading.6c4d6bb7.svg";